module.exports = __webpack_public_path__ + "img/set-up-facilities.6f1e2caf.svg";